import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { AppConfig } from "../../providers/config";
import { ClinicProvider } from '../../providers/clinic/clinic';

@IonicPage()
@Component({
  selector: 'page-program-clinics-add',
  templateUrl: 'program-clinics-add.html',
})
export class ProgramClinicsAddPage {

  program_id: string;
  program_name: string;
  user: any;
  provinces = AppConfig.Global.provinces;

  page_name: string;
  clinic: any;
  existing = false;

  addeditForm: FormGroup; 

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private auth: AuthProvider,
    private dbProvider: ClinicProvider,
    private fb: FormBuilder) {
    
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      this.program_name = user.program_name;
      this.program_id = user.program_id;
    });

    if (this.navParams.get('clinicdata')) {
      this.clinic = this.navParams.get('clinicdata')
      //console.log('Existin Pharmacy: ', this.pharmacy);
      this.page_name = 'Edit ' + this.clinic.name;
      this.addeditForm.patchValue(this.clinic);
      this.existing = true;
    } else {
      this.clinic = null;
      this.page_name = 'Add Institution';
      this.existing = false;
    }
  }

  createForm()  {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/
    let cellfaxregex: RegExp = /^\+[1-9]\d{1,14}$/

    this.addeditForm = this.fb.group({
      'name': [null, [Validators.required]],
      'type': [null, [Validators.required]],
      'program_institution_id': [null],
      'fax_number': [null, [Validators.pattern(cellfaxregex)]],
      'phone_number': [null, [Validators.pattern(phoneregex)]],
      'address': [null, [Validators.required]],
      'address2': [null],
      'city': [null, [Validators.required]],
      'province': [null, [Validators.required]],
      'postal_code': [null, [Validators.required]],
      'main_contact_name': [null],
      'main_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'main_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'main_contact_email': [null, [Validators.pattern(emailregex)]],
      'alt_contact_name': [null],
      'alt_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'alt_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'alt_contact_email': [null, [Validators.pattern(emailregex)]],
    });
  }

  save() {
    const clinic = this.addeditForm.value;
    if (this.existing) {
      this.dbProvider.updateClinic(this.program_id, this.clinic.id, clinic, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    } else {
      this.dbProvider.addClinic(this.program_id, clinic, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    }
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-clinics-add/program-clinics-add.ts